"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.reloadUser = exports.getIdToken = exports.PhoneAuth = exports.TypePhoneAuthProvider = exports.PhoneAuthProvider = exports.recaptchaVerifier = exports.sendEmailVerification = exports.sendPasswordResetEmail = exports.signInWithPhoneNumber = exports.signInWithEmailAndPassword = exports.signOut = exports.callable = void 0;
// Issue with expo and metro that we need this backwards compatibility to export PhoneAuthProvider
var app_1 = __importDefault(require("firebase/compat/app"));
require("firebase/compat/auth");
require("firebase/compat/firestore");
var _a = require('firebase/app-check'), initializeAppCheck = _a.initializeAppCheck, ReCaptchaV3Provider = _a.ReCaptchaV3Provider;
var callable_1 = require("./callable");
Object.defineProperty(exports, "callable", { enumerable: true, get: function () { return __importDefault(callable_1).default; } });
var firebaseApp;
var onlyUsedOnce = true;
var FirebaseConfig = function (config) {
    firebaseApp = !firebaseApp ? app_1.default.initializeApp(config) : firebaseApp;
    // Remove when firebase fixes this issue
    app_1.default.firestore().settings({ experimentalForceLongPolling: true, merge: true });
    if (onlyUsedOnce) {
        onlyUsedOnce = false;
        return firebaseApp;
    }
    return console.log('You are not supposed to use firebase sdk directly');
};
exports.default = FirebaseConfig;
/**
 * Export app check
 */
__exportStar(require("./appcheck"), exports);
/**
 * Export emulators
 */
__exportStar(require("./emulator"), exports);
var signOut = function () {
    return app_1.default.auth().signOut();
};
exports.signOut = signOut;
var signInWithEmailAndPassword = function (email, password) {
    return app_1.default.auth().signInWithEmailAndPassword(email, password);
};
exports.signInWithEmailAndPassword = signInWithEmailAndPassword;
var signInWithPhoneNumber = function (phoneNumber, appVerifier) {
    return app_1.default.auth().signInWithPhoneNumber(phoneNumber, appVerifier);
};
exports.signInWithPhoneNumber = signInWithPhoneNumber;
var sendPasswordResetEmail = function (email) {
    return app_1.default.auth().sendPasswordResetEmail(email);
};
exports.sendPasswordResetEmail = sendPasswordResetEmail;
var sendEmailVerification = function () {
    var _a;
    return (_a = app_1.default.auth().currentUser) === null || _a === void 0 ? void 0 : _a.sendEmailVerification();
};
exports.sendEmailVerification = sendEmailVerification;
var recaptchaVerifier = function () {
    return new app_1.default.auth.RecaptchaVerifier('recaptchaContainer', { size: 'invisible' });
};
exports.recaptchaVerifier = recaptchaVerifier;
var PhoneAuthProvider = function () {
    return new app_1.default.auth.PhoneAuthProvider();
};
exports.PhoneAuthProvider = PhoneAuthProvider;
var TypePhoneAuthProvider = function () {
    return app_1.default.auth.PhoneAuthProvider;
};
exports.TypePhoneAuthProvider = TypePhoneAuthProvider;
var PhoneAuth = function () {
    return app_1.default.auth();
};
exports.PhoneAuth = PhoneAuth;
var getIdToken = function () {
    var _a;
    return (_a = app_1.default.auth().currentUser) === null || _a === void 0 ? void 0 : _a.getIdToken(true);
};
exports.getIdToken = getIdToken;
var reloadUser = function () {
    var _a;
    return (_a = app_1.default.auth().currentUser) === null || _a === void 0 ? void 0 : _a.reload();
};
exports.reloadUser = reloadUser;
